export type ConditionType = "input" | "column";
export type ConditionTypes = ConditionType[];

export const inputCondition: ConditionType = "input";
export const defaultConditionTypes: ConditionTypes = ["input"];
export const allConditionTypes: ConditionTypes = ["input", "column"];
